export type FlexGridItemSize = 'auto' | 'fill' | 'hold' | 'equal' | number;
export type FlexGridItemOffset = 'auto' | number;

export const DEFAULT_GRID_COLUMNS = 12;
